import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SalesOrderPayment, SalesOrderPaymentDetails } from '../../models';
import { TmsWebBaseEditCreateService } from '../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderPaymentService extends TmsWebBaseEditCreateService<SalesOrderPayment, SalesOrderPaymentDetails> {
  constructor() {
    super('SalesOrderPayment', $localize`Sales Order Payment`);
  }

  getForSalesOrderHeader(id: string): Observable<SalesOrderPayment[]> {
    return this.httpService.get<SalesOrderPayment[]>(`${this.apiUrl}/SalesOrderHeader?id=${id}`);
  }

  getForSalesInvoiceHeader(ids: string[]): Observable<SalesOrderPayment[]> {
    return this.httpService.post<SalesOrderPayment[]>(`${this.apiUrl}/SalesInvoiceHeader`, { ids });
  }

  getSalesOrderPayPayment(includePaid: boolean): Observable<SalesOrderPayment[]> {
    return this.httpService.get<SalesOrderPayment[]>(`${this.apiUrl}/SalesOrderPayPayments?includePaid=${includePaid}`);
  }

  updatePaymentToInvoice(salesOrderPaymentId: string, salesInvoiceHeaderId: string, selected: boolean) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdatePaymentToInvoice`, {
      salesOrderPaymentId,
      salesInvoiceHeaderId,
      selected,
    });
  }

  paySalesOrderPayments(ids: string[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/PayPayments`, { ids });
  }

  unpaySalesOrderPayments(ids: string[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/UnpayPayments`, { ids });
  }
}
